<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>小组与组长</h2>
        <p>员工同一时间只能有一个有效小组，一个小组只能有一名有效组长</p>
      </div>
      <el-button
        type="primary"
        @click="openTeam"
      >
        新增小组
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        :data="rows"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column type="expand">
          <template #default="{ row }">
            <div class="member-head">
              <b>成员关系</b>
              <el-button
                size="small"
                type="primary"
                @click="openMember(row)"
              >
                添加成员
              </el-button>
            </div>
            <el-table :data="row.members">
              <el-table-column
                prop="user_name"
                label="员工"
              />
              <el-table-column label="身份">
                <template #default="{ row: m }">
                  <el-tag :type="m.is_group_leader ? 'warning' : 'info'">
                    {{ m.is_group_leader ? '组长' : '成员' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="effective_from"
                label="生效时间"
              />
              <el-table-column
                prop="effective_to"
                label="失效时间"
              />
              <el-table-column label="状态">
                <template #default="{ row: m }">
                  {{ m.enabled ? '有效' : '失效' }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template #default="{ row: m }">
                  <el-button
                    v-if="m.enabled"
                    link
                    type="danger"
                    @click="remove(row, m)"
                  >
                    结束关系
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="小组"
        />
        <el-table-column
          prop="branch_name"
          label="所属分部"
        />
        <el-table-column
          prop="leader_name"
          label="组长"
        />
        <el-table-column
          prop="member_count"
          label="有效成员数"
        />
        <el-table-column label="状态">
          <template #default="{ row }">
            <el-tag :type="row.enabled ? 'success' : 'info'">
              {{ row.enabled ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template #default="{ row }">
            <el-button
              link
              type="primary"
              @click="editTeam(row)"
            >
              编辑
            </el-button>
            <el-button
              link
              :type="row.enabled ? 'danger' : 'success'"
              @click="toggle(row)"
            >
              {{ row.enabled ? '停用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-model="teamDialog"
      :title="teamForm.id ? '编辑小组' : '新增小组'"
      width="480px"
    >
      <el-form label-width="90px">
        <el-form-item label="小组名称">
          <el-input v-model="teamForm.name" />
        </el-form-item>
        <el-form-item label="所属分部">
          <el-select v-model="teamForm.organizationUnitId">
            <el-option
              v-for="b in branches"
              :key="b.id"
              :label="b.name"
              :value="b.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="teamDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="saveTeam"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="memberDialog"
      title="添加成员"
      width="520px"
    >
      <el-form label-width="90px">
        <el-form-item label="员工">
          <el-select
            v-model="memberForm.userId"
            filterable
          >
            <el-option
              v-for="u in employees"
              :key="u.id"
              :label="`${u.name}（${u.branch_name || '未分部'}）`"
              :value="u.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="身份">
          <el-switch
            v-model="memberForm.leader"
            active-text="设为组长"
          />
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker
            v-model="memberForm.effectiveFrom"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker
            v-model="memberForm.effectiveTo"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            clearable
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="memberDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="saveMember"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { organizationApi } from '../api'
const rows = ref([]),
  branches = ref([]),
  employees = ref([]),
  loading = ref(false),
  teamDialog = ref(false),
  memberDialog = ref(false),
  activeTeam = ref(null),
  teamForm = reactive({ id: null, name: '', organizationUnitId: null }),
  memberForm = reactive({
    userId: null,
    leader: false,
    effectiveFrom: '',
    effectiveTo: null,
  })
const load = async () => {
  loading.value = true
  try {
    const result = await Promise.all([
      organizationApi.teams(),
      organizationApi.branches(),
      organizationApi.employees(),
    ])
    rows.value = result[0]
    branches.value = result[1]
    employees.value = result[2]
  } finally {
    loading.value = false
  }
}
const openTeam = () => {
  Object.assign(teamForm, { id: null, name: '', organizationUnitId: null })
  teamDialog.value = true
}
const editTeam = (r) => {
  Object.assign(teamForm, {
    id: r.id,
    name: r.name,
    organizationUnitId: r.organization_unit_id,
  })
  teamDialog.value = true
}
const saveTeam = async () => {
  try {
    teamForm.id
      ? await organizationApi.updateTeam(teamForm.id, teamForm)
      : await organizationApi.createTeam(teamForm)
    teamDialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  }
}
const toggle = async (r) => {
  try {
    await organizationApi.toggleTeam(r.id, !r.enabled)
    load()
  } catch (e) {
    ElMessage.error(e?.message || '操作失败')
  }
}
const openMember = (r) => {
  activeTeam.value = r
  Object.assign(memberForm, {
    userId: null,
    leader: false,
    effectiveFrom: new Date().toISOString().slice(0, 19).replace('T', ' '),
    effectiveTo: null,
  })
  memberDialog.value = true
}
const saveMember = async () => {
  try {
    await organizationApi.addTeamMember(activeTeam.value.id, memberForm)
    memberDialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  }
}
const remove = async (t, m) => {
  try {
    await ElMessageBox.confirm('确认结束该成员关系？', '提示')
    await organizationApi.removeTeamMember(t.id, m.id)
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head,
.member-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.member-head {
  margin: 8px 0 12px;
}
</style>
